import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { groupsApi } from "@/api/admin";

export function GroupsPage() {
  const qc = useQueryClient();
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["admin", "groups"],
    queryFn: () => groupsApi.list(),
  });

  const create = useMutation({
    mutationFn: () => groupsApi.create({ slug, name }),
    onSuccess: () => {
      setSlug("");
      setName("");
      qc.invalidateQueries({ queryKey: ["admin", "groups"] });
    },
  });

  const remove = useMutation({
    mutationFn: (id: string) => groupsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["admin", "groups"] }),
  });

  return (
    <div>
      <header className="mb-6">
        <h1 className="font-display text-2xl text-wm-white">Groups</h1>
        <p className="mt-1 text-sm text-wm-gray-100/60">
          Membership rolls up into role assignments.
        </p>
      </header>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (slug && name) create.mutate();
        }}
        className="mb-8 flex gap-2"
      >
        <input
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder="slug (e.g. eng-delivery)"
          className="flex-1 rounded-md border border-white/10 bg-transparent px-3 py-1.5 text-sm text-wm-white placeholder:text-wm-gray-100/40"
        />
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Display name"
          className="flex-1 rounded-md border border-white/10 bg-transparent px-3 py-1.5 text-sm text-wm-white placeholder:text-wm-gray-100/40"
        />
        <button
          type="submit"
          disabled={!slug || !name || create.isPending}
          className="rounded-md bg-wm-purple-bright px-3 py-1.5 text-sm text-wm-white disabled:opacity-50"
        >
          Create
        </button>
      </form>

      {isLoading ? (
        <p className="text-sm text-wm-gray-100/60">Loading…</p>
      ) : (
        <ul className="divide-y divide-white/5">
          {data?.groups.map((g) => (
            <li
              key={g.id}
              className="flex items-center justify-between py-3"
            >
              <div>
                <div className="text-wm-white">{g.name}</div>
                <div className="text-xs text-wm-gray-100/60">{g.slug}</div>
              </div>
              <button
                onClick={() => remove.mutate(g.id)}
                className="rounded-md border border-white/10 px-2 py-1 text-xs text-red-300 hover:bg-red-500/10"
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
